import {FC} from 'react';
import ReturnHomeButton from '../common/ReturnHomeButton';
import image500 from '../../../../assets/images/auth/500-error.png';

const Error500: FC = () => {
	return (
		<>
			{/* begin::Title */}
			<h1 className='fw-bolder fs-2qx text-gray-900 mb-4'>System Error</h1>
			{/* end::Title */}

			{/* begin::Text */}
			<div className='fw-semibold fs-6 text-gray-500 mb-7'>Something went wrong! Please try again later.</div>
			{/* end::Text */}

			{/* begin::Illustration */}
			<div className='mb-11'>
				<img src={image500} className='mw-100 mh-300px' alt='' />
			</div>
			{/* end::Illustration */}

			<ReturnHomeButton />
		</>
	);
};

export {Error500};
